module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-RegularItalic-WebS.1b70973a.woff";